import React from 'react';
import {useTranslation} from 'react-i18next';
import Card from '../../../components/common/Card';
import CreatePresentationTheme from './CreatePresentationTheme';
import PageHeader from '../../../components/common/header/PageHeader';

function CreatePresentationThemePage(): JSX.Element {
    const {t} = useTranslation();

    return (
        <div className="l-container">
            <PageHeader title={t('navigation.createTheme')} />
            <Card>
                <CreatePresentationTheme />
            </Card>
        </div>
    );
}

export default CreatePresentationThemePage;
